import { useEffect } from 'react';
import type { FeatureCollection } from 'geojson';
import L from 'leaflet';
import { GeoJSON, MapContainer, TileLayer, useMap } from 'react-leaflet';

interface MapViewProps {
  geojson: FeatureCollection | null;
  centroid: [number, number] | null;
}

function FitBounds({ geojson, centroid }: MapViewProps) {
  const map = useMap();

  useEffect(() => {
    if (geojson && geojson.features.length > 0) {
      const layer = L.geoJSON(geojson);
      const bounds = layer.getBounds();
      if (bounds.isValid()) {
        map.fitBounds(bounds.pad(0.2));
      }
      return;
    }
    if (centroid) {
      map.setView([centroid[1], centroid[0]], 11);
    }
  }, [geojson, centroid, map]);

  return null;
}

export function MapView({ geojson, centroid }: MapViewProps) {
  const center: [number, number] = centroid ? [centroid[1], centroid[0]] : [35.5, 105.5];
  return (
    <div className="map-shell">
      <MapContainer center={center} zoom={5} scrollWheelZoom className="map-canvas">
        <TileLayer
          attribution='&copy; OpenStreetMap contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <FitBounds geojson={geojson} centroid={centroid} />
        {geojson ? (
          <GeoJSON
            data={geojson}
            style={{
              color: '#0f766e',
              weight: 2,
              fillColor: '#14b8a6',
              fillOpacity: 0.18,
            }}
          />
        ) : null}
      </MapContainer>
    </div>
  );
}
